<template>
  <div class="cwSliderWrapper" v-show="isVisible">
    <cw-slider v-bind="sliderProps" @valueChanged="valueChanged"></cw-slider>
  </div>
</template>

<script>
import cwSlider from './cwSlider.vue';
import expertviewMixin from './experviewMixin';

export default {
  name: 'CwSliderWrapper',
  components: { cwSlider },
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {};
  },
  created() {
    this.$log.debug('cwSliderWrapper::created()', this.cmpConfig);
    this.applyRules();

    this.valueChanged(this.transformedValue);
  },
  computed: {
    sliderProps() {
      return {
        minValue: Number(this.cmpConfig.value.default.restrictions.min_value),
        maxValue: Number(this.cmpConfig.value.default.restrictions.max_value),
        currentValue: Number(this.transformedValue),
        showDots: true,
        hideLabels: false,
        suffix: this.getCactusString(this.cmpConfig.component.decorator.label_unit),
        distance: Number(this.cmpConfig.value.default.restrictions.step),
        labelMin: this.getCactusString(
          this.cleanStrRgx(this.cmpConfig.component.decorator.label_min)
        ),
        labelMax: this.getCactusString(
          this.cleanStrRgx(this.cmpConfig.component.decorator.label_max)
        ),
        labelHeader:
          this.getCactusString(this.cmpConfig.component.decorator.label_component) ||
          this.getCactusString(this.cmpConfig.component.decorator.label_static)
      };
    },

    transformedValue() {
      if (this.currentDataFromFwApp) {
        return this.applyTransformations(this.currentDataFromFwApp);
      }
      if (this.defaultWhenActivated) {
        return this.defaultWhenActivated;
      }
      return Number(this.cmpConfig.value.default.default);
    }
  },
  methods: {
    /**
     * Clean Strings
     * returns the 2 value of the cmpConfig => translation strings
     *
     * @TODO add optional regex validator
     */
    cleanStrRgx: function(value) {
      if (!value) return;

      return parseInt(value[1]);
    },
    valueChanged(newVal) {
      let fwApp = this.getFwApp();

      let value =
        fwApp.param === 'F_GradReduc'
          ? this.applyTransformations(newVal).toFixed(0)
          : this.applyReverseTransformations(newVal);

      this.$log.debug('cwSliderWrapper::valueChanged', {
        app: fwApp.app,
        parameter: fwApp.param,
        value: Number(value)
      });

      this.setExpertViewParams({
        app: fwApp.app,
        parameter: fwApp.param,
        value: Number(value)
      });
    }
  }
};
</script>
